import { faCode, faComment, faSliders } from '@fortawesome/free-solid-svg-icons';
import { MAX_PARAMS } from '$lib/core/script';
import CommentsPanel from './CommentsPanel.svelte';
import ParamsPanel from './ParamsPanel.svelte';
import ScriptEditor from './ScriptEditor.svelte';
import type { PanelSection } from './panel-section';

/** In rail order: the params the script reads, the script, then comments on the drawing. */
export const RIGHT_PANEL_SECTIONS: readonly PanelSection[] = [
  {
    id: 'params',
    label: 'Parameters',
    icon: faSliders,
    body: ParamsPanel,
    add: {
      label: 'Add param',
      title: 'Add a param the script reads as params.name',
      run: (editor) => editor.addParam(),
      disabled: (editor) => editor.params.length >= MAX_PARAMS,
    },
  },
  {
    id: 'script',
    label: 'Script',
    icon: faCode,
    body: ScriptEditor,
  },
  {
    id: 'comments',
    label: 'Comments',
    icon: faComment,
    body: CommentsPanel,
  },
];

/** Shown until another is asked for, since the script is what most edits change. */
export const RIGHT_PANEL_INITIAL = 'script';
